module.exports = __webpack_public_path__ + "img/side-icon-51-off.4276b7af.svg";